import { Box } from '@chakra-ui/react';
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { z } from 'zod';

import { useCreditFacilityOrThrow } from '~/contexts/CreditFacilitiesProvider';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { PortfolioReportBuilderContainer } from '~/packages/portfolio/ui/reportBuilder/PortfolioReportBuilderContainer';
import { PortfolioTemplate } from '~/packages/portfolio/ui/shared/PortfolioTemplate';

// Types
const RouteParamsStruct = z.object({
  creditFacility: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();
  const [queryParams] = useSearchParams();
  const { creditFacility: creditFacilityId } = RouteParamsStruct.parse(
    Object.fromEntries(queryParams),
  );
  const creditFacility = useCreditFacilityOrThrow(creditFacilityId);

  return (
    <PortfolioTemplate
      creditFacilityId={creditFacility.id}
      creditFacilityName={creditFacility.name}
      selectedTab="reportBuilder"
    >
      <PortfolioReportBuilderContainer
        organizationId={user.organization.id}
        creditFacilityId={creditFacility.id}
      />
    </PortfolioTemplate>
  );
};

// Exports
export const Route = () => {
  const flags = useFeatureFlags();
  if (!flags.showExploReportBuilder) {
    return <Navigate to="/portfolio/overview/facilities" />;
  }
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/portfolio/overview/facilities" />;
      }}
    >
      <Box width="100%" padding="2.5rem">
        <RouteBase />
      </Box>
    </RouteErrorBoundary>
  );
};
